import { Form, Card, Table, Button } from 'react-bootstrap';
import { Formik, FieldArray } from 'formik';
import PropTypes from 'prop-types';
import { WithConfirmation } from '../common';
import DeleteIcon from '../DeleteIcon';
import '../../assets/styles/react-select.scss';

const RemoveNotificationSubscriber = ({ deleteMember }) => {
  const RemoveWithConfirmation = WithConfirmation(DeleteIcon);
  const RemoveModalProps = {
    title: `Are you sure you want to delete the recipient . Continue?`,
    action: deleteMember,
    actionBtnText: 'Yes',
  };
  return <RemoveWithConfirmation modalProps={RemoveModalProps} />;
};

RemoveNotificationSubscriber.propTypes = {
  deleteMember: PropTypes.func,
};

const EmailNotificationSettings = ({
  recipientUsers = [],
  handleUpdateNotifications,
  handleRemoveNotificationRecipient,
}) => {
  const hasNotificationType = (notifications, type) =>
    notifications.some((n) => n.type === type);

  const toggleNotificationType = (notifications, type) => {
    const exists = notifications.some((n) => n.type === type);
    if (exists) {
      return notifications.filter((n) => n.type !== type);
    }
    return [
      ...notifications,
      {
        type,
        channels: ['email', 'in-app'], // Default channels
      },
    ];
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{ recipientUsers }}
      onSubmit={(values) => {
        handleUpdateNotifications(values);
      }}
    >
      {(formikprops) => (
        <Form
          id="email-summaries"
          onSubmit={formikprops.handleSubmit}
          className="needs-validation m-0 p-0"
        >
          <div className="table-responsive" style={{ overflowY: 'hidden' }}>
            <Table hover bordered size="sm" className="card-table">
              <thead className="thead-light">
                <tr>
                  <th>User</th>
                  <th className="text-center">Exceeded Break Limit</th>
                  <th className="text-center">Daily Limit</th>
                  <th className="text-center">Worksession Update</th>
                  <th className="text-center">Time Off Request</th>
                  <th className="text-center">Remove</th>
                </tr>
              </thead>
              <tbody>
                <FieldArray
                  name="recipientUsers"
                  render={() =>
                    formikprops.values.recipientUsers.map((rUser, index) => (
                      <tr key={index}>
                        <td>
                          <strong className="d-block">
                            {`${rUser.userId.firstName} ${
                              rUser.userId.lastName || ''
                            }`}
                          </strong>
                          <span className="text-muted">
                            {rUser.userId.email}
                          </span>
                        </td>
                        <td align="center">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input form-check-border"
                              checked={hasNotificationType(
                                rUser.notifications,
                                'break_limit_exceeded'
                              )}
                              onChange={() => {
                                const updated = toggleNotificationType(
                                  rUser.notifications,
                                  'break_limit_exceeded'
                                );
                                formikprops.setFieldValue(
                                  `recipientUsers[${index}].notifications`,
                                  updated
                                );
                              }}
                            />
                          </div>
                        </td>
                        <td align="center">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input form-check-border"
                              checked={hasNotificationType(
                                rUser.notifications,
                                'daily_limit'
                              )}
                              onChange={() => {
                                const updated = toggleNotificationType(
                                  rUser.notifications,
                                  'daily_limit'
                                );
                                formikprops.setFieldValue(
                                  `recipientUsers[${index}].notifications`,
                                  updated
                                );
                              }}
                            />
                          </div>
                        </td>
                        <td align="center">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input form-check-border"
                              checked={hasNotificationType(
                                rUser.notifications,
                                'work_session_update'
                              )}
                              onChange={() => {
                                const updated = toggleNotificationType(
                                  rUser.notifications,
                                  'work_session_update'
                                );
                                formikprops.setFieldValue(
                                  `recipientUsers[${index}].notifications`,
                                  updated
                                );
                              }}
                            />
                          </div>
                        </td>
                        <td align="center">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input form-check-border"
                              checked={hasNotificationType(
                                rUser.notifications,
                                'time_off_request'
                              )}
                              onChange={() => {
                                const updated = toggleNotificationType(
                                  rUser.notifications,
                                  'time_off_request'
                                );
                                formikprops.setFieldValue(
                                  `recipientUsers[${index}].notifications`,
                                  updated
                                );
                              }}
                            />
                          </div>
                        </td>
                        <td align="center">
                          <RemoveNotificationSubscriber
                            deleteMember={() =>
                              handleRemoveNotificationRecipient(
                                rUser.userId._id
                              )
                            }
                          />
                        </td>
                      </tr>
                    ))
                  }
                />
              </tbody>
            </Table>
          </div>
          <Card.Footer>
            <div className="d-flex justify-content-end align-items-center">
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </div>
          </Card.Footer>
        </Form>
      )}
    </Formik>
  );
};

EmailNotificationSettings.propTypes = {
  recipientUsers: PropTypes.array,
  handleUpdateNotifications: PropTypes.func,
  handleRemoveNotificationRecipient: PropTypes.func,
};

export default EmailNotificationSettings;
